package app.nestbridge.feature.main.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Person
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.karawek.core.ui.theme.CoreTheme
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource

@Composable
internal fun ProfileAvatarButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    profilePictureUrl: String? = null,
    userName: String? = null,
) {
    IconButton(
        onClick = onClick,
        modifier = modifier,
    ) {
        Box(
            modifier = Modifier
                .size(34.dp)
                .background(
                    color = CoreTheme.colors.surfaceVariant,
                    shape = CircleShape,
                ),
            contentAlignment = Alignment.Center,
        ) {
            if (profilePictureUrl != null) {
                KamelImage(
                    resource = { asyncPainterResource(profilePictureUrl) },
                    contentDescription = userName ?: "Profile",
                    contentScale = ContentScale.Crop,
                    modifier = Modifier
                        .size(34.dp)
                        .clip(CircleShape),
                    onLoading = { _ ->
                        // Show placeholder while loading
                        Icon(
                            imageVector = Icons.Outlined.Person,
                            contentDescription = "Loading profile",
                            tint = CoreTheme.colors.onBackground,
                            modifier = Modifier.size(18.dp),
                        )
                    },
                    onFailure = { _ ->
                        // Show fallback icon on error
                        Icon(
                            imageVector = Icons.Outlined.Person,
                            contentDescription = "Profile",
                            tint = CoreTheme.colors.onBackground,
                            modifier = Modifier.size(18.dp),
                        )
                    },
                )
            } else {
                Icon(
                    imageVector = Icons.Outlined.Person,
                    contentDescription = "Profile",
                    tint = CoreTheme.colors.onBackground,
                    modifier = Modifier.size(18.dp),
                )
            }
        }
    }
}
